import { render, staticRenderFns } from "./vTelInput.vue?vue&type=template&id=67c09695&scoped=true"
import script from "./vTelInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./vTelInput.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c09695",
  null
  
)

export default component.exports